/* eslint-disable no-param-reassign */
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { apiClient } from '../../../lib/apiClient';

export const createEvictionIntake = createAsyncThunk(
  'requests/createEvictionIntake',
  async (body, { rejectWithValue }) => {
    try {
      const { data } = await apiClient.post(`cp/api/requests/evictionIntake`, body);
      return data;
    } catch (e) {
      return rejectWithValue(e.response.data);
    }
  },
);

const initialState = {
  error: null,
};

export const requestsSlice = createSlice({
  name: 'requests',
  initialState,
  reducers: {},
  extraReducers: {
    [createEvictionIntake.rejected]: (state, action) => {
      state.error = action.payload;
    },
  },
});

export default requestsSlice.reducer;
